import { Col, Row } from '@design-system/components/grid/grid';
import {
  Desc,
  TitleRow,
} from '../../../promotions/view/components/FormTypography';
import { Errors } from '../../../promotions/view/components/Errors';
import { TextInput } from '../../../promotions/view/components/TextInput';

import { Button } from '@design-system/components/button/button';
import { ExtrasFormVM } from '../viewModel/extrasForm.viewModel';
import { alignRight, wrapper, divider } from './form.css';
import { TemplatesList } from '@client/new/pages/challenges/view/components/TemplatesList';
import SuperTooltip from '@client/new/components/SuperTooltip/SuperTooltip';
import { Typography } from '@design-system/components/typography/typography';
import { extrasVM } from '../Extras.page';

export const LinkForm = ({ register, ...p }: ExtrasFormVM) => {
  const vm = extrasVM.useValue();
  const isSaving = vm.savingSlides?.has(vm.currentId);

  return (
    <form>
      <Col data-testid="ContentLinkForm" gap="xl" className={wrapper}>
        <TitleRow
          title="Link"
          button={{
            children: isSaving ? 'Saving...' : 'Save',
            color: 'neutral',
            loading: isSaving,
            onClick: p.lazyDispatch('Submit'),
          }}
        />
        <Errors data={p.errors} />

        <TextInput label="Link" {...register('url')} required />
        <TextInput label="Title" {...register('title')} required />

        <Col className={divider}>
          <Row>
            <Typography variant="body" size="large" fontWeight="medium">
              Banner image
            </Typography>
            <SuperTooltip templateId="profile-banner" hideNavigation />
          </Row>
          <Row>
            <Col>
              <Desc>
                Upload an image. <br />
                Minimum image dimensions: 1005 x 450
                {register('coverImage').error && (
                  <Typography variant="body" size="small" color="ERROR-100">
                    {register('coverImage').error}
                  </Typography>
                )}
              </Desc>
            </Col>
            <Col>
              <div className={alignRight}>
                <Button
                  color="primary"
                  disabled={p.isUploading || p.values.coverImage !== ''}
                  variant="text"
                  size="medium"
                  onClick={() => {
                    p.dispatch('StartBannerUpload');
                  }}
                  loading={p.isUploading}
                >
                  Upload
                </Button>
                <input
                  type="file"
                  accept={'image/*'}
                  ref={p.uploadInputRef}
                  onChange={(ev) =>
                    ev.target.files &&
                    p.dispatch('UploadBanner', ev.target.files[0])
                  }
                  multiple={false}
                  hidden
                />
              </div>
            </Col>
          </Row>
        </Col>
        <Row>
          <TemplatesList
            urls={[p.values.coverImage]}
            onRemove={() => p.dispatch('RemoveBanner')}
          />
        </Row>
      </Col>
    </form>
  );
};
